import { useQuery as useQueryParams } from '@kiper/hooks';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useRemoteConfig from '../../../hooks/useRemoteConfig';
import LoadingPage from '../../../components/LoadingPage';
import { InviteGuestProvider } from '../../../store/InviteGuest';
import { CustomInvite } from './CustomInvite';
import { useFetchInviteGuest } from './hooks';
import { MainInvite } from './MainInvite';
import { PorterSummitEditionInvite } from './PorterSummitEditionInvite';
import InviteError, { InviteErrorTypes } from '../../../components/InviteError';

export default function InviteGuest() {
  const history = useHistory();
  const querystring = useQueryParams();
  const guestHash = querystring?.get('q')?.replace(/ /g, '+') || '';

  const inviteGuestQueryData = useFetchInviteGuest({ guestHash });

  const { condominiumPersonContextId } =
    inviteGuestQueryData?.data?.getInviteGuest || {};

  const enablePersonalizedInvite = useRemoteConfig({
    path: 'inviteGuest.enablePersonalizedInvite',
    condominium: Number(condominiumPersonContextId),
  });

  const specialInvitePorterSummit = useRemoteConfig({
    path: 'inviteGuest.specialInvitePorterSummit',
    condominium: Number(condominiumPersonContextId),
  });

  useEffect(() => {
    if (enablePersonalizedInvite) {
      history.push(`/convite-personalizado?q=${guestHash}`);
    }
  }, [condominiumPersonContextId, enablePersonalizedInvite, guestHash]);

  const inviteModel = () => {
    if (specialInvitePorterSummit) return 'porter-summit';
    if (inviteGuestQueryData?.data?.getInviteGuest?.customInvite)
      return 'custom';
    return 'default';
  };

  const RenderInvite = {
    default: <MainInvite />,
    'porter-summit': <PorterSummitEditionInvite />,
    custom: <CustomInvite />,
  };

  const isInviteValid = inviteData => {
    if (!inviteData) return false;
    return !!(inviteData.id || inviteData.hashId);
  };

  if (inviteGuestQueryData?.loading || !guestHash) return <LoadingPage />;

  if (
    inviteGuestQueryData?.error ||
    !isInviteValid(inviteGuestQueryData?.data?.getInviteGuest)
  ) {
    return <InviteError type={InviteErrorTypes.INVALID} />;
  }

  return (
    <InviteGuestProvider
      inviteGuestQueryData={inviteGuestQueryData}
      guestHash={guestHash}
    >
      {RenderInvite[inviteModel()]}
    </InviteGuestProvider>
  );
}
